import * as React from "react";
import { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgPricingBasic = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" width="1em" height="1em" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<clipPath id="a"><path d="M0 0h32v32H0z" /></clipPath><g clipPath="url(#a)"><path fill="currentColor" fillRule="evenodd" d="M26.816 10.177V2.941h-5.412v2.153L15.992 0 .485 14.598l.706.832 1.824-1.714V32h25.97V13.716l1.796 1.687.734-.805zm-4.328-6.14h3.248v5.127l-3.248-3.056zm-9.881 26.994v-9.696h6.425v9.695zm15.293 0h-7.899V20.36h-8.37v10.664H4.095V12.697L15.997 1.495l7.73 7.27 3.088 2.913 1.085 1.019z" clipRule="evenodd" /></g></svg>;
export default SvgPricingBasic;